
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic-material/[keyword]",
      function () {
        return require("private-next-pages/topic-material/[keyword].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic-material/[keyword]"])
      });
    }
  